import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'tax_classifications',
  inputShow: gql`
    query taxClassifications($input: TaxClassificationQueryInput) {
      taxClassifications(input: $input) {
        id
        label
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    group: 'Billing',
    label: 'Tax classification',
  },
};
